import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Plus, Search } from "lucide-react";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [role, setRole] = useState("all");
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [schools, setSchools] = useState([]);
  const [form, setForm] = useState({ role: "school", name: "", email: "", phone: "", password: "", school_id: "" });

  const load = () => {
    const p = new URLSearchParams();
    if (role !== "all") p.set("role", role);
    if (q) p.set("q", q);
    api.get(`${V1}/admin/users?${p.toString()}`).then((r) => setUsers(r.data || []));
  };
  useEffect(() => { load(); }, [role, q]);
  useEffect(() => { api.get(`${V1}/schools?limit=100`).then((r) => setSchools(r.data.items || [])); }, []);

  const create = async () => {
    try {
      await api.post(`${V1}/admin/users`, form);
      toast.success("Kullanıcı eklendi");
      setOpen(false); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Eklenemedi"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-users-page">
      <div className="flex justify-between items-center">
        <div>
          <div className="overline text-accent">Yönetim</div>
          <h1 className="font-display text-3xl font-bold">Kullanıcılar</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="new-user-btn"><Plus className="h-4 w-4" /> Yeni Kullanıcı</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Kullanıcı Oluştur</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Rol</Label><Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}><SelectTrigger data-testid="user-role"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="admin">admin</SelectItem><SelectItem value="school">school</SelectItem><SelectItem value="parent">parent</SelectItem></SelectContent></Select></div>
              <div><Label>Ad Soyad</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="user-name" /></div>
              <div><Label>E-posta</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="user-email" /></div>
              <div><Label>Telefon</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
              <div><Label>Şifre</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="user-password" /></div>
              {form.role === "school" && (
                <div><Label>Okul</Label>
                  <Select value={form.school_id} onValueChange={(v) => setForm({ ...form, school_id: v })}>
                    <SelectTrigger data-testid="user-school"><SelectValue placeholder="Okul seç" /></SelectTrigger>
                    <SelectContent>{schools.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
              )}
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Vazgeç</Button><Button onClick={create} data-testid="save-user-btn">Kaydet</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="flex gap-3 items-end">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input placeholder="Ara..." value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="user-search" />
        </div>
        <Select value={role} onValueChange={setRole}>
          <SelectTrigger className="w-40"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tümü</SelectItem>
            <SelectItem value="admin">admin</SelectItem>
            <SelectItem value="school">school</SelectItem>
            <SelectItem value="parent">parent</SelectItem>
            <SelectItem value="student">student</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr><th className="text-left p-3">Ad</th><th className="text-left p-3">Rol</th><th className="text-left p-3">E-posta</th><th className="text-left p-3">Telefon</th><th className="text-left p-3">Aktif</th></tr>
          </thead>
          <tbody>
            {users.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground">Kullanıcı bulunamadı.</td></tr>}
            {users.map((u) => (
              <tr key={u.id} className="border-t border-border">
                <td className="p-3">{u.name}</td>
                <td className="p-3"><span className="px-2 py-0.5 bg-muted rounded text-xs uppercase">{u.role}</span></td>
                <td className="p-3">{u.email || "-"}</td>
                <td className="p-3 font-mono text-xs">{u.phone || "-"}</td>
                <td className="p-3">{u.active ? "✔︎" : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
